module.exports = __webpack_public_path__ + "img/home_glxt@2x.5a2dba85.png";